/* eslint-disable require-jsdoc */
import React from 'react';
// import React, {useEffect} from 'react';
import {defaultImg} from '../../utils/defaultImg';
import {isValid} from '../../utils/validate';
import hasProp from 'hasprop';
import VenueSocial from './VenueSocial';


// import initMap from './map/map';

// import {Loader} from '@googlemaps/js-api-loader';


const cleanedVenueWebsite = (rawVenueWebsite) => {
  if (rawVenueWebsite) {
    const cleanedVenueWebTemp =
    rawVenueWebsite.replace('https://', '');
    const cleanedVenueWeb =
    cleanedVenueWebTemp.replace('http://', '');
    // console.log('cleanedVenueWebsite', cleanedVenueWeb);
    return cleanedVenueWeb;
  }
};


// const mapFunc = () => {
//   const mapObject = document.getElementById('map2');
//   return mapObject;
// };


const venue = (props) => {
  // useEffect(() => {
  //   const loader = new Loader({
  //     apiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
  //     version: 'weekly',
  //   });
  //   if (isValid(props.venue)) {
  //     loader.load().then(() => {
  //       map = new google.maps.Map(mapFunc(), {
  //         center: {lat: 40.731, lng: -73.935},
  //         zoom: 8,
  //       });
  //       console.log('venue loader.load().map', map);
  //     });
  //   }

  //   console.log('venue.js props', props);
  // });


  return (
    <div>
      {hasProp(props, ['venue']) ?

      <div>

        <section className="hearby-section-playingat">
          <div className="hearby-details-row">
            <div className="hearby-col hearby-col-100">
              <h2>

                {isValid(props.venue.venueName) ?
                <div>
                  <h2>
                    <span className="hearby-title-subhead">Playing at</span>
                    <span
                      className="hearby-mainhead">{props.venue.venueName}
                    </span>
                  </h2>
                </div> :
                null}

              </h2>
            </div>
          </div>
        </section>

        <section className="hearby-section-eventvenuedetails">
          <div className="hearby-details-row">

            <div className="hearby-col hearby-col-50">
              <img src={props.venue.venueImage}
                onError={(e)=>{
                  e.target.onerror = null;
                  e.target.src=defaultImg();
                }}
                className="hearby-venue-details-image"
                alt=""
                srcSet={`${props.venue.venueImage} 408w, 
                  ${props.venue.venueImage} 300w`}
                sizes='(max-width: 408px) 100vw, 408px'
              />
            </div>

            <div className="hearby-col hearby-col-50">
              <div className="hearby-eventvenuedetails-content">
                <div className="hearby-event-venue-summary">
                  <p>
                    { isValid(props.venue.description) ?
                      props.venue.description: null}
                  </p>
                </div>

                <div className="hearby-event-message">
                  <p>
                     Given Covid, check with venue for changes.
                    {isValid(props.venue.phone) ? ' Call venue': null}
                    <br />
                    {isValid(props.venue.phone) ? props.venue.phone : null}
                    {isValid(props.venue.website) ? ' or ': null}
                    <br />

                    {isValid(props.venue.website) ?
                      <a href={
                        `${props.venue.website}`}
                      target="_blank" rel='noreferrer'>
                        {cleanedVenueWebsite(props.venue.website)}
                      </a>: null}
                  </p>
                </div>

                <VenueSocial socialInfo={props.venue}/>

              </div>
            </div>

          </div>

          {/* <div className="hearby-details-row">
            <div className="hearby-col hearby-col-100">
              <div>Google Map Goes Here!</div>
              {console.log('venue.js props in jsx', props)}
              <div id='map2' style = {{height: '300px', width: '370px'}}></div>
            </div>
          </div> */}
        </section>

      </div>: null}

    </div>
  );
};

export default venue;
